const DESKTOP_QUERY = "(min-width: 821px)"

export class ReaderSidebar {
  constructor({ element, sidebar, toggle, panels, buttons, onSearchVisibilityChanged, onDesktopLayout }) {
    this.element = element
    this.sidebar = sidebar
    this.toggle = toggle
    this.panels = panels
    this.buttons = buttons
    this.onSearchVisibilityChanged = onSearchVisibilityChanged
    this.onDesktopLayout = onDesktopLayout
  }

  toggleOpen() {
    return this.setOpen(!this.sidebar.classList.contains("is-open"))
  }

  setOpen(open) {
    this.sidebar.classList.toggle("is-open", open)
    this.element.classList.toggle("is-sidebar-open", open)
    this.toggle.setAttribute("aria-expanded", String(open))
    this.notifySearchVisibility()

    if (!window.matchMedia(DESKTOP_QUERY).matches) return Promise.resolve()
    return Promise.resolve(this.onDesktopLayout?.())
  }

  activate(selected) {
    this.panels.forEach((panel) => panel.hidden = panel.dataset.panel !== selected)
    this.buttons.forEach((button) => button.classList.toggle("is-active", button.dataset.panelName === selected))
    this.notifySearchVisibility()
  }

  activePanel() {
    return this.panels.find((panel) => !panel.hidden)?.dataset.panel
  }

  searchVisible() {
    return this.sidebar.classList.contains("is-open") && this.activePanel() === "search"
  }

  closeAfterNavigation() {
    if (window.matchMedia(DESKTOP_QUERY).matches) return Promise.resolve()
    return this.setOpen(false)
  }

  notifySearchVisibility() {
    this.onSearchVisibilityChanged?.(this.searchVisible())
  }
}
